import { render, staticRenderFns } from "./PageGestionCompteProf.vue?vue&type=template&id=2bec054a&scoped=true"
import script from "./PageGestionCompteProf.vue?vue&type=script&lang=js"
export * from "./PageGestionCompteProf.vue?vue&type=script&lang=js"
import style0 from "./PageGestionCompteProf.vue?vue&type=style&index=0&id=2bec054a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bec054a",
  null
  
)

export default component.exports